import React, {useState, useEffect} from 'react';
import {MARKER_TYPES} from '@homeaway/react-map-components';
import MapComponent from './Map';
const PopularDestinationMap = ({
    destinations,
    highlightedItemLbsId,
    changeHighlightItem,
    mapOptions,
}) => {
    const [mapMarkers, setMapMarkers] = useState([]);
    const [highlightedId, setHighlightedId] = useState();
    useEffect(() => {
        setMapMarkers(
            destinations.map((destination, index) => {
                const marker = {
                    type: MARKER_TYPES.DESTINATION,
                    key: `${index}-${destination.lbsId}`,
                    position: {lat: destination.lat, lng: destination.lng},
                    id: destination.lbsId,
                    itemNumber: index + 1,
                    numMaxMarkers: destinations.length,
                    label: `${index + 1}`,
                };
                return marker;
            })
        );
    }, [destinations]);

    useEffect(() => {
        const highlightedMarker = destinations.filter(
            (destination) => destination.lbsId === highlightedItemLbsId
        );
        if (highlightedMarker && highlightedMarker.length > 0) {
            setHighlightedId(
                `${highlightedMarker[0].lat}${highlightedMarker[0].lng}`
            );
        } else {
            setHighlightedId(null);
        }
    }, [destinations, highlightedItemLbsId]);

    const onMarkerClick = (uuid) => {
        const selectedListing = mapMarkers.filter(
            (marker) => `${marker.position.lat}${marker.position.lng}` === uuid
        );
        if (selectedListing && selectedListing.length > 0) {
            changeHighlightItem(
                selectedListing[0].id,
                selectedListing[0].itemNumber
            );
        }
    };
    return (
        <>
            <MapComponent
                mapOptions={mapOptions}
                markers={mapMarkers}
                hoveredMarker={highlightedId}
                onMarkerClick={onMarkerClick}
            />
        </>
    );
};
export default PopularDestinationMap;
